export const breakpoints = ["450px", "769px", "1025px"];
